import { useState } from "react";
import { Button } from "react-bootstrap";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";

export default {
  title: "CatalogIndex/ConfirmDeleteModal",
  component: ConfirmDeleteModal,
};

export const SoftDelete = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open</Button>
      <ConfirmDeleteModal
        open={open}
        title="Delete phase?"
        message="The phase will be moved to Archived."
        onConfirm={() => {
          alert("confirmed");
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export const PermanentDelete = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open</Button>
      <ConfirmDeleteModal
        open={open}
        title="Permanently delete approval rule?"
        message="This will permanently delete this approval rule. Continue?"
        confirmLabel="Permanently Delete"
        onConfirm={() => {
          alert("confirmed");
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};
